import React from 'react';
import { t } from '../../../../modules/infra/i18n';
import BasicFormField from '../../../common/formFields/basicFormField';
import UploadImageAsset from './UploadImageAsset';

const BrandPageForm = () => (
  <div className="layout">
    <div className="c-heading c-heading--lightgrey c-wrapper u-pv0 u-mt-- u-mb-" >{t('brand:form.brand_page_settings_heading')}</div>
    <UploadImageAsset name="extension.brandLogoImage" label={t('brand:form.logo_image_label')} />
    <UploadImageAsset name="extension.brandBackgroundImage" label={t('brand:form.background_image_label')} />
    <BasicFormField
      placeholder={t('brand:form.name_placeholder')}
      label={t('brand:form.name_label')}
      name="extension.brandName"
      maxLength="255"
    />
    <BasicFormField
      placeholder={t('brand:form.route_placeholder')}
      label={t('brand:form.route_label')}
      name="extension.route"
      maxLength="255"
    />
  </div>
);

export default BrandPageForm;
